
import React, { useState, useEffect } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import * as Request from '../../common/request';
import Page from '../../components/page';

import './index.less';

const PageModel = props => {
	const [list, setList] = useState([]);

	const getData = async () => {
		const { id } = props.match.params;
		console.log('传过来的;', id);
		if (!id) return;

		const result = await Request.get({
			url: `/equipment/mylist`,
			data: { id }
		});
		if (!result) return;
		setList(result.data.list);
	};


	useEffect(() => {
		console.log('-----111---------');
		getData();
	}, [ 123 ]);

	return (
		<Page {...{
			title: '设备管理',
			...props
		}}>
			<section className="devices-container" style={{ minHeight: window.innerHeight - 50 }}>
				{list && list.length > 0 && list.map((item,index)=>{
					return item.equipmentType === 1? (
						<div className="devices-content" key={index}>
							<div className='device-item'>
								<div className='device-item-title'>{item.equipmentName}</div>
								{
									item.equipmentStaus == 0
										&& <div className='device-item-status'>正在运行中...</div>
										
								}
								{
									item.equipmentStaus == 1
										&& <div className='device-item-stop'>油烟超标...</div>
								}
								{
									item.equipmentStaus == 2
										&& <div className='device-item-stop'>断电停机中...</div>
								}

							</div>
							<div className='device-item-upkeep'>最后保养：{item.equipmentUpkeepDays}</div>
							<div className='device-item-upkeep'>当前行时间/保养周期 ：{item.totalRunningTimes}/{item.equipmentUpkeepTime}(小时)<div style={{ marginLeft: '10px', color: 'red' }}>{(parseFloat(item.equipmentUpkeepTime)-parseFloat(item.totalRunningTimes)) < 10 ? '(需保养)' : ''}</div></div>
						</div>
					):null
				})}
				
			</section>
		</Page>
	);
};

export default PageModel;
